// JavaScript for the public marketing pages — Stimulus and one controller, and
// nothing else. Deliberately does NOT import a stylesheet: marketing.css is a
// separate CSS entry, and two JS entries importing the same CSS module makes
// Rollup emit it for only one of them. See docs/tailwind-migration.md, trap 0.
//
// It also does not import controllers/index.js, which glob-registers every
// controller in the app — those pull in jQuery, React and Turbo.
import { Application } from "@hotwired/stimulus";
import AgePresetsController from "../controllers/age_presets_controller";
import LightboxController from "../controllers/lightbox_controller";
import PreviewModeController from "../controllers/preview_mode_controller";

const application = Application.start();

application.register("age-presets", AgePresetsController);
application.register("lightbox", LightboxController);
application.register("preview-mode", PreviewModeController);
